import { Card, Skeleton } from "antd";
import React, { Component } from "react";
import TabHeader from "../../components/Tabs/TabHeader";
import {
  FaEye,
  FaTrashAlt,
  FaPen,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
const { Meta } = Card;
export default class Teams extends Component {
  state = {
    loading: false,
    showDltModal: false,
  };
  
  componentDidMount() {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false });
    }, 2000); 
  }

  closeDltModal = () => { 
    this.setState({showDltModal : false})
  }

  render() {
    const { loading, showDltModal } = this.state;
    return (
      <div className="teams-wrapper">
        {showDltModal && <DeleteModal name="الفريق" closeDltModal={this.closeDltModal} /> }
        <div className="container">
          <TabHeader showType="teams" title="الفرق" />
          <div className="teams-content-wrapper cards-list-wrapper">
            {
              loading ? (
                [0, 1, 2, 3, 4, 5].map((skl) => (
                  <Skeleton key={skl} active avatar paragraph={{ rows: 4 }} />
                ))
              ) : (
                    [0, 1, 2, 3, 4, 5].map((skl) => 
                    
                <Card
                  className="card-view-holder"
                  hoverable
                  actions={[
                    <>
                     <Link to="/team-info">
                    <FaEye
                      key="view"
                      />
                      عرض
                      </Link>
                    </>,
                    <>
                    <Link to="/add-team">
                    <FaPen key="edit" />
                    تعديل
                    </Link>
                    </>,
                    <>
                    <div onClick={() => this.setState({showDltModal : true}) }>
                    <FaTrashAlt key="delete" />
                    حذف 
                    </div>
                    </>,
                  ]}
                  loading={false}
                >
                  <Meta
                    title="فريق العروبه"
                    description={<div className="team-desc">
                        <div className="team-num">12</div>
                        <span>موظف</span>
                    </div>}
                  />
                </Card>)
              )
            }
          </div>
        </div>
      </div>
    );
  }
}
